module.exports = __webpack_public_path__ + "static/media/Night3.fc4e7763.jpg";